import ApiService from '@/services/core/api.service'

const VenueService = {
  async get (query) {
    return ApiService.get(`admin/items?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/items', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/items/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/items/${payload.id}`)
  }
}

export default VenueService
